'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);

var _Color;
/******************************************************************************
 * Copyright (c) 2017, TigerGraph Inc.
 * All rights reserved.
 * Project: GVIS
 * Brief: GVIS library Color Class.
 *
 * Created on: Oct 7th, 2016
 *      Author: Xiaoke Huang
 ******************************************************************************/

/**
 * Color class for GVIS.
 */
var Color = /*#__PURE__*/function () {
  function Color(theme) {
    _classCallCheck__default["default"](this, Color);
    if (theme === undefined) {
      theme = 'c60';
    }
    this.colorSchema = Color[theme];
    this.colorMap = {};
    this.colorArray = this.parseColorSchema(this.colorSchema);
  }

  /**
   * Initialize color for a list of types.
   * @param  {string[]} types the list of types, example: ['Company', 'Car', 'Member']
   * @return {this}           [description]
   */
  // public initialization(types: string[]): this {
  //   types.forEach(function (type) {
  //     this.getColor(type);
  //   });

  //   return this;
  // }

  /**
   * get color for a type. Dunamically update the colorMap while getting color.
   * @type  {string} id for the color.
   * @return {string} color string.
   */
  return _createClass__default["default"](Color, [{
    key: "parseColorSchema",
    value:
    /**
     * current color schema color string.
     * @type {string}
     */

    /**
     * color array which is parsed from colorSchema.
     * @type {string[]}
     */

    /**
     * key is the type, it will be mapped to a index value or a color string.
     * Index will be used to get the color string in colorArray, by colorArray[index % colorArray.length];
     * Color string will be used as color.
     */

    function parseColorSchema(schema) {
      try {
        var _context;
        return _mapInstanceProperty__default["default"](_context = schema.match(/.{6}/g)).call(_context, function (x) {
          return '#' + x;
        });
      } catch (err) {
        var _context2;
        console.error(err, 'Use default color schema c10.');
        this.colorSchema = Color.c10;
        return _mapInstanceProperty__default["default"](_context2 = this.colorSchema.match(/.{6}/g)).call(_context2, function (x) {
          return '#' + x;
        });
      }
    }
  }, {
    key: "getColor",
    value: function getColor(type) {
      var result = '#000000';
      try {
        if (type === undefined) {
          throw new Error('getColor for a unknow type.');
        }
        if (this.colorMap[type] === undefined) {
          this.colorMap[type] = {
            index: _Object$keys__default["default"](this.colorMap).length
          };
        }
        if (this.colorMap[type].color !== undefined) {
          result = this.colorMap[type].color;
        } else {
          result = this.colorArray[this.colorMap[type].index % this.colorArray.length];
        }
      } catch (err) {
        console.error(err);
        result = '#000000';
      }
      return result;
    }

    /**
     * Customize a color for a type, it will override the index color.
     * @type  {string}
     * @color  {string}
     * @return {this}
     */
  }, {
    key: "setColor",
    value: function setColor(type, color) {
      this.colorMap[type] = this.colorMap[type] || {};
      this.colorMap[type].color = color;
      return this;
    }

    /**
     * Change the color shcema theme. It will change color schema and color array after set a acceptable theme.
     * @theme  {string}  Names of schema: 'c10', 'c10a', 'c10b', 'c10c', 'c10d', 'c10e', 'c20', 'c30', 'c40', 'c50', 'c60'
     * @return {this}
     */
  }, {
    key: "setColorTheme",
    value: function setColorTheme(theme) {
      this.setColorSchema(Color[theme]);
      return this;
    }

    /**
     * Change the color schema for the color Array.
     * @schema  {string}
     * @return {this}
     */
  }, {
    key: "setColorSchema",
    value: function setColorSchema(schema) {
      this.colorSchema = schema;
      this.colorArray = this.parseColorSchema(schema);
      return this;
    }

    /**
     * Reset the color map object. Does not change the color schema or color array.
     * @return {this}
     */
  }, {
    key: "reset",
    value: function reset() {
      this.colorMap = {};
      return this;
    }

    /**
     * use to generate random RGB color string. The random color could be duplicated.
     * @return {string} random RGB color string.
     */
  }, {
    key: "randomColor",
    value: function randomColor() {
      var co = function co(lor) {
        return (lor += [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f'][Math.floor(Math.random() * 16)]) && lor.length === 6 ? lor : co(lor);
      };
      return '#' + co('');
    }

    /**
     * use to return the privagte memeber color array. It will retrun an array contains currently used colors.
     * @return {string[]} [description]
     */
  }, {
    key: "getColorArray",
    value: function getColorArray() {
      return this.colorArray;
    }
  }]);
}();
_Color = Color;
_defineProperty__default["default"](Color, "c10", '1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf');
_defineProperty__default["default"](Color, "c10a", 'aec7e8ffbb7898df8aff9896c5b0d5c49c94f7b6d2c7c7c7dbdb8d9edae5');
_defineProperty__default["default"](Color, "c10b", '393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39');
_defineProperty__default["default"](Color, "c10c", 'e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6');
_defineProperty__default["default"](Color, "c10d", '3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476');
_defineProperty__default["default"](Color, "c10e", 'a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9');
_defineProperty__default["default"](Color, "c20", _Color.c10 + _Color.c10a);
_defineProperty__default["default"](Color, "c30", _Color.c10 + _Color.c10a + _Color.c10b);
_defineProperty__default["default"](Color, "c40", _Color.c10 + _Color.c10a + _Color.c10b + _Color.c10c);
_defineProperty__default["default"](Color, "c50", _Color.c10 + _Color.c10a + _Color.c10b + _Color.c10c + _Color.c10d);
_defineProperty__default["default"](Color, "c60", _Color.c10 + _Color.c10a + _Color.c10b + _Color.c10c + _Color.c10d + _Color.c10e);

exports.Color = Color;
